
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthentificationService } from 'src/app/services/auth/authentification.service';
import {AffichageCGUService} from '../../components/affichage-cgu/services/affichage-cgu.service';

@Injectable({
  providedIn: 'root',
})


export class AcceptedCguGuard implements CanActivate {
  statuCgu : string;
  typeUser: string;

  constructor(private readonly router: Router, private readonly authentificationService: AuthentificationService, private readonly affichageCGUService: AffichageCGUService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.typeUser = this.authentificationService.getTypeUser();
    if (this.typeUser === 'ASSURE' || this.typeUser === 'ENTREPRISE') {
      this.statuCgu = this.authentificationService.getStatusCgu();
      if (this.statuCgu === '-1' || this.statuCgu === '1') {
        // CGU not accepted
        this.router.navigate(['/affichage-cgu']);
        return false;

      } else {
        // CGU accepted, go to home
        return true;
      }
    } else {
      // User type is not ASSURE or ENTREPRISE, go to home
      return true;
    }
  }
}
